import { MonthYear } from '@common/neo.tax';
import { Button, useModal } from '@ui-components/neo.tax';

import { MonthYearPicker } from '../../month-year-picker';
import { MonthYearPeriodFormType } from '../forms.types';
import { ConfirmShortYearChangeModal } from './ConfirmShortYearChangeModal';

export const MonthYearPeriodForm = ({ form }: { form: MonthYearPeriodFormType }): React.ReactElement | null => {
  const { isOpen: isConfirmShortYearChangeModalOpen, setIsOpen } = useModal();
  const handleOpenModal = (): void => {
    setIsOpen(true);
  };

  const handleCloseModal = (): void => {
    setIsOpen(false);
  };

  return (
    <>
      <MonthYearPicker
        id={`${form.id}-start`}
        clearButtonId={`${form.id}-clear-btn`}
        value={form.value?.startMonthYear}
        label={form.monthYearStartLabel}
        disabled={form.monthYearPeriodDisabled}
        onChange={(newMonthYearStart: MonthYear | null): void => {
          if (newMonthYearStart && form.value?.endMonthYear) {
            form.onChange({ startMonthYear: newMonthYearStart, endMonthYear: form.value?.endMonthYear });
          }
        }}
      />
      <MonthYearPicker
        id={`${form.id}-end`}
        clearButtonId={`${form.id}-clear-btn`}
        value={form.value?.endMonthYear}
        label={form.monthYearEndLabel}
        disabled={form.monthYearPeriodDisabled}
        onChange={(newMonthYearEnd: MonthYear | null): void => {
          if (newMonthYearEnd && form.value?.startMonthYear) {
            form.onChange({ endMonthYear: newMonthYearEnd, startMonthYear: form.value?.startMonthYear });
          }
        }}
      />
      <Button size="base" variant="form" rounded="regular" disabled={form.disabled} onClick={handleOpenModal}>
        {form.submitText}
      </Button>

      {form.value && (
        <ConfirmShortYearChangeModal
          shortYearPeriod={form.value}
          close={handleCloseModal}
          isOpen={isConfirmShortYearChangeModalOpen}
          onConfirm={form.onSubmit}
          loading={form.loading}
        />
      )}
    </>
  );
};
